import { Component, OnInit, OnDestroy } from '@angular/core';
import { ThemeService, ThemeConfig } from '../../services/theme/theme.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-theme-selector',
  templateUrl: './theme-selector.component.html',
  styleUrls: ['./theme-selector.component.scss']
})
export class ThemeSelectorComponent implements OnInit, OnDestroy {
  isOpen = false;
  currentTheme = 'moderno';
  themes: ThemeConfig[] = [];
  private themeSubscription: Subscription = new Subscription();

  constructor(private themeService: ThemeService) {}

  ngOnInit(): void {
    this.themes = this.themeService.getAllThemes();
    this.themeSubscription = this.themeService.currentTheme$.subscribe(theme => {
      this.currentTheme = theme;
    });
  }

  ngOnDestroy(): void {
    this.themeSubscription.unsubscribe();
  }

  toggleSelector(): void {
    this.isOpen = !this.isOpen;
  }

  selectTheme(themeName: string): void {
    this.themeService.setThemeFromQuery(themeName);
    this.isOpen = false;
  }

  getCurrentThemeDisplayName(): string {
    const theme = this.themeService.getThemeByName(this.currentTheme);
    return theme ? theme.displayName : 'Moderno';
  }

  getCurrentThemeColor(): string {
    const theme = this.themeService.getThemeByName(this.currentTheme);
    return theme ? theme.colors.primary : '#2563eb';
  }

  getThemeDescription(themeName: string): string {
    const descriptions: Record<string, string> = {
      moderno: 'Diseño limpio y contemporáneo',
      corporativo: 'Profesional y formal',
      creativo: 'Colorido y dinámico',
      minimalista: 'Simple y elegante'
    };
    return descriptions[themeName] || '';
  }
}
